import React from 'react';

export default class RouteComponent extends React.Component
{
	static childContextTypes = {
		location: React.PropTypes.object
	};

	getChildContext() {
		return { location: this.props.location }
	}
}


// WEBPACK FOOTER //
// ./src/components/RouteComponent.js